import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomainService } from 'app/core/services/domain.service';
import { Subject } from 'rxjs';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { LicenseService } from 'app/core/services/license.service';
import { of } from 'rxjs/observable/of';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { AuthService } from 'app/core/services/auth.service';

@Component({
  selector: 'itpx-self-register-validate',
  templateUrl: './self-register-validate.component.html',
  styleUrls: ['../register-user/register-user.component.css', '../login/login.component.css', './self-register-validate.component.css']
})
export class SelfRegisterValidateComponent extends LoadingPage implements OnInit {

  private form: FormGroup;
  private domain: any;
  private mailSentTo: string;
  constructor(private fb: FormBuilder,
    private domainService: DomainService,
    private licenseService: LicenseService,
    private authService: AuthService, ) { super() }

  ngOnInit() {
    this.domain = this.domainService.getDomain();
    this.form = this.fb.group({
      username: [null, [Validators.required, Validators.email]],
    });
  }

  onRegister() {

    this.licenseService.completeSelfRegistration(this.form.getRawValue()).catch(e => { this.form.get('username').setErrors({ custom: { message: 'This email already exists.' } }, { emitEvent: false }); return of({ data: e.json() }) })
      .neverError()
      .bindToLifecycle(this)
      .subscribe(res => {
        if (res && res.data && !res.data.error) {
          this.mailSentTo = this.form.get('username').value;
        }

      });
  }
  login() {
    this.authService.login();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/self-register/self-register-validate.component.ts